/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const swap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m11 4.75 2-2m0 0 2 2m-2-2v7.833a2.5 2.5 0 0 1-5 0V5.25a2.5 2.5 0 0 0-5 0v7.833m2-2-2 2m0 0-2-2"
    />
  </svg>
)
export default swap
